export default function columnDataMatcher(res, simple=true) {
    const { keyField, columns, data } = res;
    let myIndex = columns.findIndex(item => item.id === keyField)
    let values = data.map((item) => item[myIndex])
    // se simple sta a true, ritorno l'array con solo il valore principale
    // se simple sta a false, ritorno tutto l'array dentro data
    return simple ? values : data
}